import { withInstall } from '../../utils';
import Search from './src/search.vue';

export * from './src/search';

export const ISearch = withInstall(Search); // 增加类型

export default ISearch;
